var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex-column hp-10 px-7",
      class: "step" + _vm.currentStepNumber
    },
    [
      _vm._t("header"),
      _vm._v(" "),
      _vm._t("content", [
        _c(
          "transition",
          { attrs: { name: "fade", mode: "out-in" } },
          [_c("router-view")],
          1
        )
      ]),
      _vm._v(" "),
      _vm._t("footer", [
        _c("stepper-indicator", {
          attrs: {
            nbStep: _vm.nbStep,
            currentStepNumber: _vm.currentStepNumber
          }
        })
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }